query findManualResultingEventMarkets(
  $eventId: UUID!
) {
  event: eventByEventId(eventId: $eventId) {
    markets: marketsByEventId(
      filter: {
        source: {
          in: ["INTERNAL_AGGREGATION"],
        },
      }
    ) {
      nodes {
        marketId
        marketCode
        marketType
        marketSummary
        selections
        displayStatus
        offeringStatus
        resultingStatus
        status
        inPlay
        source
        operatorId
      }
    }
  }
}
